import React, { useState, useContext } from "react";
import { formatListWithParameter, formatmarkInfo, truncateText } from "../../utils";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  addActiveFn,
  withNewTitleAndName
} from "../action-buttons/ActionButtonGenerator";
import ListComponent from "./ListComponent";
import { useTranslation } from "react-i18next"; /* Added Line */
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import TextInput from "../form-fields/TextInput";
import Select from "../form-fields/Select";
import ReactDatePicker from "../form-fields/ReactDatePicker";
import { Field } from "formik";
import request from "../../services/request";
import DemandUpdate from "../../pages/home/demand-update/DemandUpdate";
import DocumentUpdate from "../../pages/home/document-update/DocumentUpdate";
import { ThemeContext } from '../../../context/ThemeContext';
import { DEMAND_TYPES } from "../../shared/enums";
import Checkbox from "../form-fields/Checkbox";
import NumberInput from "../form-fields/NumberInput";

DemandList.propTypes = {};

function DemandList(props) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [t] = useTranslation(); /* Added Line */
  const [filters, setFilters] = useState([]);
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [companies, setCompanies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [statu, setStatu] = useState(0);
  const [returnReason, setReturnReason] = useState("");
  const [selectedRow, setSelectedRow] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
          talepTurId: props.talepTurId
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };
  const onRejectPending = () => {
    request({
      url: "yonlendirilecek-talep/reddet",
      method: "POST",
      data: {
        body: {
          id: selectedRow.id,
          redNedeni: rejectReason,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        props.setRefreshList(!props.refreshList);
        setShowModal(false);
      }
    });
  };

  const onRejectDirected = () => {
    request({
      url: "atanan-talep/iade-et",
      method: "POST",
      data: {
        body: {
          id: selectedRow.id,
          iadeNedeni: returnReason,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        props.setRefreshList(!props.refreshList);
        setShowModal(false);
      }
    });
  };

  const typeCheck = (type, filterValues = []) => {
    let index = filterValues.findIndex((fv) => fv == type);

    if (index != -1) {
      return true;
    }

    return false;
  };

  const onUpdateButtonClicked = (selectedRow) => {

    if (selectedRow.talepDurum.id == 1 || selectedRow.talepDurum.id == 5) {
      setStatu(1);
    } else if (selectedRow.talepDurum.id == 2) {
      setStatu(2);
    } else if (selectedRow.talepDurum.id == 3) {
      setStatu(3);
    } else {
      setStatu(4);
    }
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12 mt-3">
        <Accordion
          className="accordion accordion-rounded-stylish accordion-bordered"
          defaultActiveKey="0"
        >
          <div className="accordion__item" key={"filter"}>
            <Accordion.Toggle
              as={Card.Text}
              eventKey={"filter"}
              className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
              onClick={() =>
                setActiveIndicatorInLeftPosition(
                  activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                )
              }
            >
              <span className="accordion__header--icon"></span>
              <span className="accordion__header--text">
                {t("sozlesmeler.filtreleme")}
              </span>
              <span className="accordion__header--indicator"></span>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={"filter"} className="accordion__body">
              <div className="accordion__body--text">
                <Filters
                  configPointUrl="talep-girisi/filter-config"
                  configParameterName="talepTurId"
                  configParameterValue={props.talepTurId}
                  configReqType={"POST"}
                  setConfigData={(data) => setConfigData(data)}
                  setRefreshList={props.setRefreshList}
                  refreshList={props.refreshList}
                  setFilters={setFilters}
                >
                  <Field
                    name="yurtici"
                    label={t("demandList.yurtici")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={configData && configData.yurtici}
                  />
                  <Field
                    name="sirketDurumu"
                    label={t("demandList.sirketDurumu")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={configData && configData.sirketDurumu}
                  />
                  <Field
                    name="islemNo"
                    label={t("davaIcraSavcilik.islemNo")}
                    colNumber="3"
                    component={TextInput}
                  />
                  <Field
                    name="grupID"
                    label={t("davaIcraSavcilik.grup")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={configData && configData.grupSirketleri}
                    onChangeFunc={(opt) => onGroupChanged(opt)}
                  />
                  <Field
                    name="sirketID"
                    label={t("davaIcraSavcilik.grupSirketi")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={
                      companies.length > 0
                        ? companies.map((c) => {
                          return { value: c.id, label: c.name };
                        })
                        : configData && configData.sirketler
                    }
                  />
                  <Field
                    name="dosyaTuru"
                    label={t("davaIcraSavcilik.dosyaTuru")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={configData && configData.dosyaTurleri}
                  />
                  <Field
                    name="talepDurumuID"
                    label={t("demandStates.talepDurumu")}
                    colNumber="3"
                    component={Select}
                    placeholder={t("formFields.allPlaceHolder")}
                    options={configData && configData.talepDurumu}
                  />
                  {
                    typeCheck(props.talepTurId, [
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA
                    ]) && (
                      <Field
                        name="szlThmBedelTuru"
                        label={t(
                          ((props.talepTurId === DEMAND_TYPES.SOZLESME) || (props.talepTurId == DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI) || (props.talepTurId === DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA) || (props.talepTurId === DEMAND_TYPES.TIO_SOZLESME) || (props.talepTurId === DEMAND_TYPES.GH_IS_HUKUKU))
                            ? "demandCreate.sozlesmeBedeli"
                            : "documentUpdate.tahminiBedel"
                        )}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={
                          configData && configData.szlTahminiBedelTurleri
                        }

                      />
                    )}
                  <Field
                    name="konu"
                    label={t("davaIcraSavcilik.konu")}
                    colNumber="3"
                    component={TextInput}
                  />
                  {/* <Field
                    name="isGucuBirimId"
                    label={t("demandUpdate.isGucuBirim")}
                    colNumber="3"
                    component={Select}
                    options={configData && configData.isGucu}
                  /> */}
                  <Field
                    name="acilisTarihiMin"
                    label={t("ihtarnameler.baslangicTarihi")}
                    colNumber="3"
                    component={ReactDatePicker}
                    onChangeFunc={(date) => {setStartDate(date)}}
                    maxDate={endDate}
                  />
                  <Field
                    name="acilisTarihiMax"
                    label={t("ihtarnameler.bitisTarihi")}
                    colNumber="3"
                    component={ReactDatePicker}
                    onChangeFunc={(date) => {setEndDate(date)}}
                    minDate={startDate}
                  />
                  
                  {typeCheck(
                    props.talepTurId, 
                    [89, 90, 92, 16, 64, 17, 91, 31, 83, 18, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.TH_KAMULASTIRMA]) 
                    && (
                      <Field
                        name="onemli"
                        label={t("demandList.importantInfo")}
                        colNumber="3"
                        component={Checkbox}
                      />
                  )}
                  <div className="d-flex container mt-0"></div>
                  {
                    typeCheck(props.talepTurId, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                    ]) && (
                        <Field
                        name="muddeabihBaslangic"
                        label={t("demandList.enAz")}
                        colNumber="3"
                        component={NumberInput}
                        title={t("demandList.muddeabih")}
                      />
                    )}
                    {
                    typeCheck(props.talepTurId, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                    ]) && (
                        <Field
                        name="muddeabihBitis"
                        label={t("demandList.enCok")}
                        colNumber="3"
                        component={NumberInput}
                        title=""
                      />
                    )}
                </Filters>
              </div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      </div>
      <div className="col-md-12 mt-3">
        {statu == 1 && (
          <DemandUpdate
            extraButton
            extraButtonOnClick={onRejectPending}
            pageType={1}
            extraButtonText={t("actionButtonGenerator.red")}
            type={1}
            /* title={t("anaSayfa.bekleyenTalepler")} */
            title={selectedRow?.talepDurumName}
            endpoint={"yonlendirilecek-talep/avukatAta"}
            okButtonText={t("actionButtonGenerator.atamaYap")}
            refreshList={props.refreshList}
            setRefreshList={props.setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            setShowModal={setShowModal}
            setRejectReason={setRejectReason}
          />
        )}

        {statu == 2 && (
          <DemandUpdate
            extraButton
            extraButtonOnClick={onRejectDirected}
            pageType={1}
            extraButtonText={t("actionButtonGenerator.iadeEt")}
            type={3}
            /* title={t("anaSayfa.yonlendirilmisTalepler")} */
            title={selectedRow?.talepDurumName}
            endpoint={"atanan-talep/dosyaya-donustur"}
            endPointUrl2={"atanan-talep/tamamla"}
            endPointUrl3={"atanan-talep/kaydet"}
            endPointUrl4={"atanan-talep/baslat"}
            okButtonText={t(
              selectedRow?.talepTur?.departmentId == 2
                ? "actionButtonGenerator.dosyayaDonustur"
                : "actionButtonGenerator.numaraVer"
            )}
            secondSubmitButttonText={t(
              selectedRow?.talepTur?.departmentId == 2
                ? "actionButtonGenerator.tamamla"
                : "actionButtonGenerator.numaraVermeden"
            )}
            thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
            fourthSubmitButttonText={t("actionButtonGenerator.baslat")}
            refreshList={props.refreshList}
            setRefreshList={props.setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            setShowModal={setShowModal}
            setReturnReason={setReturnReason}
          />
        )}

        {statu == 3 && (
          <DemandUpdate
            extraButton
            extraButtonOnClick={onRejectDirected}
            extraButtonText={t("actionButtonGenerator.iadeEt")}
            pageType={2}
            type={2}
            /* title={t("anaSayfa.surecDevamEdenTalepler")} */
            title={selectedRow?.talepDurumName}
            endpoint={"atanan-talep/dosyaya-donustur"}
            endPointUrl2={"atanan-talep/tamamla"}
            endPointUrl3={"atanan-talep/kaydet"}
            okButtonText={t(
              selectedRow?.talepTur?.departmentId == 2
                ? "actionButtonGenerator.dosyayaDonustur"
                : "actionButtonGenerator.numaraVer"
            )}
            secondSubmitButttonText={t(
              selectedRow?.talepTur?.departmentId == 2
                ? "actionButtonGenerator.tamamla"
                : "actionButtonGenerator.numaraVermeden"
            )}
            thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
            refreshList={props.refreshList}
            setRefreshList={props.setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            setShowModal={setShowModal}
            setReturnReason={setReturnReason}
          />
        )}

        {statu == 4 && (
          <DocumentUpdate
            /* title={t("anaSayfa.tamamlananlar")} */
            title={selectedRow?.talepDurumName}
            endpoint={"dosya/guncelle"}
            okButtonText={t("actionButtonGenerator.kaydet")}
            refreshList={props.refreshList}
            setRefreshList={props.setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            setShowModal={setShowModal}
          />
        )}
      </div>
      <div className="col-md-12">
        <ListComponent
          entityName=""
          endpoint="talep-girisi/listele"
          keyField="id"
          refreshList={props.refreshList}
          hideSelection = {true}
          customBody={{
            talepTurId: props.talepTurId,
            filters: filters,
          }}
          columns={[
            {
              dataField: "id",
              text: `${t("demandList.islemNo")}`,
              sort: true,
              headerStyle: {
                width: 64
              }
            },
            {
              dataField: "onemli",
              text: `${t("demandList.importantInfo")}`,
              sort: false,
              formatter: formatmarkInfo,
              headerStyle: {
                width: 92
              },
              hidden: typeCheck(props.talepTurId, [89, 90, 92, 16, 64, 17, 91, 31, 83, 18, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.TH_KAMULASTIRMA]) ? false : true,
            },
            {
              dataField: "companyGroup",
              text: `${t("demandList.grup")}`,
              formatter: (data) => formatListWithParameter(data, "name"),
              sort: true,
            },
            {
              dataField: "company.name",
              text: `${t("demandList.grupSirketi")}`,
              sort: true,
            },
            {
              dataField: "ilgiliSirketName",
              text: `${t("demandList.ilgiliSirket")}`,
              sort: true,
            },
            {
              dataField: "talepTur.talepTuru",
              text: `${t("demandList.talepTuru")}`,
              sort: true,
            },
            {
              dataField: "talepDurum.talepDurumName",
              text: `${t("demandList.talepDurumu")}`,
              sort: true,
            },
            {
              dataField: "konu",
              text: `${t("demandList.konu")}`,
              formatter: (data) => truncateText(data, 35, 30),
              sort: true,
            },
            {
              dataField: "",
              text: `${t("demandList.isGücüBirim")}`,
              formatter: (data, row) => (row.isGucuBirimi ? row.isGucuBirimiName : ""),
              sort: true,
            },
            {
              dataField: "bedel",
              text: `${t("demandList.muddeabih")}`,
              sort: true,
              hidden: typeCheck(props.talepTurId, [
                DEMAND_TYPES.DAVA_YENI_TALEP,
                DEMAND_TYPES.TH_KAMULASTIRMA,
                DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              ]) ? false : true,
            },
            {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
              sort: false,
            },
          ]}
          actionButtonsObject={{
            actions: [
              addActiveFn(
                pushToParams(
                  withNewTitleAndName(
                    ABT.EDIT,
                    "Görüntüle",
                    "EDIT_WITH_TITLE"
                  ),
                  onUpdateButtonClicked
                ),
                (row) => !row.departmanYoneticisiMi
              ),
              addActiveFn(
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                (row) => {
                 return  row.departmanYoneticisiMi}
              ),
              pushToParams(ABT.EXCEL_EXPORT, {
                requestTo: "file/download-excel",
                talepTurId: props.talepTurId,
              }),
            ],
            generator: DefaultActionButtonGenerator,
          }}
        />
      </div>
    </div>
  );
}

export default DemandList;
